import { render, staticRenderFns } from "./zrsy.vue?vue&type=template&id=d2119b02&scoped=true"
import script from "./zrsy.vue?vue&type=script&lang=js"
export * from "./zrsy.vue?vue&type=script&lang=js"
import style0 from "./zrsy.vue?vue&type=style&index=0&id=d2119b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2119b02",
  null
  
)

export default component.exports